import React from 'react';
import Icon from '../../../components/AppIcon';

const NextStepsSection = ({ dealership }) => {
  const voucherValue = dealership?.voucherValue || 150;
  const voucherCurrency = dealership?.voucherCurrency || 'Euro';
  const voucherDisplay = `${voucherValue} ${voucherCurrency}`;

  const steps = [
    {
      number: 1,
      icon: 'FileSearch',
      title: 'Automatische Prüfung',
      description: 'Ihre Daten werden automatisch geprüft und validiert',
      duration: '2-3 Werktage'
    },
    {
      number: 2,
      icon: 'Building2',
      title: 'UBA-Weiterleitung',
      description: 'Weiterleitung an das Umweltbundesamt zur finalen Genehmigung',
      duration: '4-6 Wochen'
    },
    {
      number: 3,
      icon: 'Ticket',
      title: 'Gutschein-Aktivierung',
      description: `Ihr ${voucherDisplay} Wertgutschein wird aktiviert und versendet`,
      duration: 'Nach Genehmigung'
    }
  ];

  return (
    <div className="bg-card rounded-xl shadow-lg p-6 md:p-8 mb-8 border border-border">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center">
          <Icon name="ListChecks" size={24} color="var(--color-primary)" />
        </div>
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground">
          Wie geht es weiter?
        </h2>
      </div>

      <div className="space-y-6">
        {steps?.map((step, index) => (
          <div key={step?.number} className="relative">
            {/* Connecting Line */}
            {index < steps?.length - 1 && (
              <div className="absolute left-6 top-16 bottom-0 w-0.5 bg-border hidden md:block" />
            )}

            <div className="flex gap-4 md:gap-6">
              {/* Step Number Circle */}
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-gradient-to-br from-primary to-primary/80 rounded-full flex items-center justify-center shadow-md relative z-10">
                  <span className="text-white font-bold text-lg">{step?.number}</span>
                </div>
              </div>

              {/* Step Content */}
              <div className="flex-1 pb-6">
                <div className="bg-muted/50 rounded-lg p-4 md:p-5 hover:bg-muted/70 transition-smooth">
                  <div className="flex items-start gap-3 mb-2">
                    <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                      <Icon name={step?.icon} size={18} color="var(--color-primary)" />
                    </div>
                    <div className="flex-1">
                      <h3 className="font-heading font-semibold text-foreground text-base md:text-lg mb-1">
                        {step?.title}
                      </h3>
                      <p className="text-sm text-muted-foreground mb-2">
                        {step?.description}
                      </p>
                      <div className="flex items-center gap-2">
                        <Icon name="Clock" size={14} color="var(--color-muted-foreground)" />
                        <span className="text-xs font-medium text-muted-foreground">
                          {step?.duration}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Additional Information */}
      <div className="mt-6 p-4 bg-primary/5 border border-primary/20 rounded-lg">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm font-semibold text-foreground mb-1">
              Gesamtdauer: ca. 6-8 Wochen
            </p>
            <p className="text-xs text-muted-foreground">
              Die Bearbeitungszeit kann je nach Auslastung des Umweltbundesamtes variieren. 
              Sie werden per E-Mail über jeden Statuswechsel informiert.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NextStepsSection;